export const shortWord = (text: string, length: number) => {
    if(text.length > 7) {
      return text.slice(0, length) + '...';
    }
    return text
}